class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.endMessage = this.dataset.endMessage || '';
    this.hideOnComplete = this.dataset.hideOnComplete === 'true';
  }

  connectedCallback() {
    const date = this.dataset.date; // "MM-DD-YYYY"
    const time = this.dataset.time; // "HH:MM" (24hr)
    const tz = this.dataset.timezone; // "-0500"

    const [month, day, year] = date.split('-');
    const [hour, minute] = time.split(':');

    // build ISO string with timezone offset
    const tzFormatted = `${tz.slice(0, 3)}:${tz.slice(3)}`; // -0500 -> -05:00
    const isoString = `${year}-${month}-${day}T${hour}:${minute}:00${tzFormatted}`;

    this.endDate = new Date(isoString).getTime();

    this.daysEl = this.querySelector('.days .countdown-timer--column--number');
    this.hoursEl = this.querySelector('.hours .countdown-timer--column--number');
    this.minutesEl = this.querySelector('.minutes .countdown-timer--column--number');
    this.secondsEl = this.querySelector('.seconds .countdown-timer--column--number');

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance <= 0) {
      clearInterval(this.interval);
      this.setZero();
      this.onComplete();
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  setZero() {
    if (this.daysEl) this.daysEl.textContent = '00';
    if (this.hoursEl) this.hoursEl.textContent = '00';
    if (this.minutesEl) this.minutesEl.textContent = '00';
    if (this.secondsEl) this.secondsEl.textContent = '00';
  }

  onComplete() {
    if (this.hideOnComplete) {
      const wrapperId = this.dataset.wrapperId;
      const wrapper = wrapperId ? document.getElementById(wrapperId) : this.closest('.countdown-banner-section');
      if (wrapper) {
        wrapper.classList.add('timer-hidden');
      } else {
        this.classList.add('timer-hidden');
      }
    } else if (this.endMessage) {
      this.innerHTML = `<div class="countdown-timer--end-message">${this.endMessage}</div>`;
    }
  }
}
customElements.define('countdown-timer', CountdownTimer);